module.exports = __webpack_public_path__ + "static/media/main idea.f59be4dc.mp3";